var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "router-link",
    {
      staticClass: "t-mar--l-mi t-button",
      class: [
        { "t-disabled": !_vm.$user.can("update", "workspace") },
        `t-button--${_vm.variant}`,
        { "t-link t-fs--body": !_vm.type },
      ],
      attrs: { to: { name: "pricing_page" } },
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.canShowTrial
              ? _vm.trailAltText
                ? _vm.$t("generic.button.free_14_days")
                : _vm.$t("generic.button.start_trial")
              : _vm.$t("generic.button.upgrade")
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }